import { type Href, router } from 'expo-router';
import React from 'react';
import {
    BodySmallEmphasized,
    Button,
    ButtonSize,
    ButtonVariant,
    isWeb,
    SafeAreaView,
    useThemeColors,
    YStack,
} from 'smoothie';

interface FullScreenErrorProps {
    hasBackButton?: boolean;
    message?: string;
    buttonLabel?: string;
    fallbackRoute?: Href;
    resetError?: () => void;
}

const FullScreenError = ({
    hasBackButton = true,
    message,
    buttonLabel,
    fallbackRoute = '/',
    resetError,
}: FullScreenErrorProps) => {
    const { getColor } = useThemeColors();
    return (
        <SafeAreaView style={{ flex: 1, backgroundColor: getColor('$white') }}>
            <YStack flex={1} alignItems="center" padding={20}>
                <BodySmallEmphasized
                    color="$red1100"
                    marginTop={isWeb ? '30vh' : 'auto'}
                    marginBottom={isWeb ? '10vh' : 'auto'}
                >
                    {message ?? 'Oops! Something went wrong.'}
                </BodySmallEmphasized>
                {hasBackButton && (
                    <Button
                        variant={ButtonVariant.PRIMARY}
                        size={ButtonSize.LARGE}
                        text={buttonLabel ?? 'Go back'}
                        buttonProps={{ maxWidth: 400 }}
                        onPress={() => {
                            if (resetError) {
                                resetError();
                            }

                            if (router.canGoBack()) {
                                router.back();
                            } else {
                                router.replace(fallbackRoute);
                            }
                        }}
                    />
                )}
            </YStack>
        </SafeAreaView>
    );
};

export default FullScreenError;
